<template name="visitorDetailList">
  <div class="visitor-detail-list">
    <div v-for="(visitorDetail, idx) in visitorDetailList" :key="idx" class="visitor-detail-item">
      <div class="row title">
        <div class="userName">
          {{ visitorDetail.userName }}
        </div>
        <div class="edit" @click="editVisitorDetail(idx)">
          {{$t('modify')}}
        </div>
      </div>
      <div class="content">
        <div class="content-title">
          {{ isForKOInnerVisitor ? $t('Internal') : '' +  $t('visitorInfo') }}
        </div>
        <div class="content-item">
          <div class="content-item-desc">
            {{ $t('Info') }}
          </div>
          <div class="content-item-detail">
            {{ visitorDetail.userName }} {{ visitorDetail.contact }}
          </div>
        </div>
        <div class="content-item" v-show="material.answer !== null &&
          (material.answer && material.answer.length) &&
          (isKOSystem ? (isForKOInnerVisitor || !material.isCompany) : true)"
          :class="{ 'img-content-item' : material.materialType === 7 || material.materialType === 9 }"
          v-for="(material, idx) in visitorDetail.materials" :key="idx">
          <div class="content-item-desc">
            {{ material.materialTitleTemplate }}
          </div>
          <div class="content-item-detail multi-answer" v-if="material.materialType===2">
            <span v-for="(item, index) in material.answer" :key="index">
              {{ item }}
            </span>
          </div>
          <div class="content-item-detail multi-answer" v-else-if="material.materialType===6">
            <span v-for="(item, index) in material.names" :key="index">
              {{ item }}
            </span>
          </div>
          <div class="content-item-detail img-item" v-else-if="material.materialType===7 || material.materialType===9">
            <img v-for="(answer, idx) in material.answer" :src="answer">
          </div>
          <div class="content-item-detail" v-else>
            {{ material.answer }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">

export default {
  name: 'visitorDetailList',
  props: {
    visitorDetailList: Array,
    isKOSystem: Boolean,
    isForKOInnerVisitor: Boolean,
  },
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
    editVisitorDetail(idx) {
      this.$emit('editVisitorDetail', idx);
    },
  },
};
</script>

<style scoped lang="scss">
  .visitor-detail-list {
    .visitor-detail-item {
      .title {
        padding: 0 20px;
        margin: auto;
        border-bottom: 1px solid #f0f1f2;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        line-height: 50px;
        display: flex;
        align-items: center;
        .userName {
          font-weight: bold;
          color: #4a4a4a;
        }
        .edit {
          font-size: 13px;
          color: #e42029;
          padding: 6px 10px;
          border-radius: 17px;
          border: solid 1px #e42029;
          line-height: 10px;
        }
      }
      .content {
        padding: 16px 20px;
        .content-title {
          padding-left: 20px;
          background: url('../assets/images/user-copy@3x.png') no-repeat left center;
          background-size: 17px auto;
          color: #4a4a4a;
          font-weight: bold;
        }
        .content-item {
          display: flex;
          font-size: 13px;
          margin-top: 10px;
          justify-content: space-between;
          .content-item-desc {
            color: #929292;
          }
          .content-item-detail {
            max-width: 50%;
            word-break: break-all;
            color: #4a4a4a;
            &.multi-answer {
              span {
                display: block;
                text-align: right;
              }
            }
            &.img-item {
              max-width: 100%;
            }
            img {
              max-width: 100%;
              display: block;
              height: auto;
            }
          }
          &.img-content-item {
            flex-direction: column;
          }
        }
      }
      border-bottom: 1px solid #f0f1f2;
    }
  }
</style>
